import { callApi } from "../../helpers/apiHelper";

/**
 *
 * @param {string} id the guid of the logged in user
 * @param {number} skip number of records to skip
 * @param {number} top how many records to return
 * @param {number} statusId the statusId to filter by
 * @param {boolean} sortByStarred whether to filter starred
 * @param {boolean} sortAscending whether to sort ascending or descending
 * @returns {[{}]} an array of comments
 */
export const getComments = async (
  id,
  skip,
  top,
  statusId,
  sortByStarred,
  sortAscending
) => {
  // determine if we're going to sort by starred
  const filterStarred = sortByStarred
    ? "and Media/any(media: media/Starred eq true)"
    : "";

  // determine the sort direction
  const direction = sortAscending ? "asc" : "desc";
  let params = {};
  params["$filter"] = `currentStatusId eq ${statusId} ${filterStarred}`;
  params["$skip"] = skip;
  params["$top"] = top;
  params["$orderBy"] = `created ${direction}`;
  params["$expand"] = 'Media,Item($expand=Implementation),Item($expand=Location)';

  return await callApi(`odata/comment/${id}`, { params });
};

/**
 *
 * @param {*} userId
 * @returns
 */
export const getUserData = async (userId) => {
  return await callApi(`api/profile?userId=${userId}`);
};

/**
 *
 * @param {*} memberId
 * @returns user profile data.
 */
export const getProfileData = async (memberId) => {
  return await callApi(`api/profile/${memberId}`);
};
